export default "__VITE_ASSET__DN5jFRsI__"